import { makeAutoObservable } from 'mobx';
import { NotificationStore } from './stores/notificationStore';
import { WorkspaceStore } from './stores/workspaceStore';
import { ProjectStore } from './stores/projectStore';
import { TaskStore } from './stores/taskStore';
import { AlertNotificationStore } from './stores/alertNotificationStore';
import { UserModel } from './models/user';
import { AppStore } from './stores/appStore';
import { ProjectTemplateStore } from './stores/projectTemplateStore';
import { ReportStore } from './stores/reportStore';
import { UserProfileDataInterface } from '../interfaces/AuthInterface';
import { ViewStore } from './stores/viewStore';
import { SettingStore } from './stores/SettingStore';

export class RootStore {
  notificationStore: NotificationStore = new NotificationStore();
  workspaceStore: WorkspaceStore = new WorkspaceStore();
  projectStore: ProjectStore = new ProjectStore();
  projectTemplateStore: ProjectTemplateStore = new ProjectTemplateStore();
  taskStore: TaskStore = new TaskStore();
  alertNotificationStore: AlertNotificationStore = new AlertNotificationStore();
  appStore: AppStore = new AppStore();
  viewStore: ViewStore = new ViewStore();
  settingStore: SettingStore = new SettingStore();
  reportStore: ReportStore = new ReportStore();
  currentUser: UserModel | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setCurrentUser(currentUser: UserProfileDataInterface) {
    this.currentUser = this.workspaceStore.currentWorkspace?.users?.find((user) => user.id === currentUser.id) || null;
  }

  //clear all stores
  clearAllStores() {
    this.notificationStore.clearInboxData();
    this.projectStore.clearProjectData();
    this.taskStore.clearTaskData();
    this.projectTemplateStore.clearProjectTemplateData();
    this.reportStore.clearReportData();
    this.settingStore.clearSettingData();
    this.appStore.clearAppData();
  }
}

export const rootStore = new RootStore();
